import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { applyDefaultErrorHandling } from '@schir-int-client/ngrx-helpers';
import { catchError, map, switchMap } from 'rxjs/operators';
import { loadApiRootAction, loadApiRootSuccessAction } from './api-root.actions';
import { ApiRootService } from './api-root.service';

@Injectable()
export class ApiRootEffects {
	constructor(
		private actions: Actions,
		private apiRootService: ApiRootService
	) {}

	loadApiRoot = createEffect(() =>
		this.actions.pipe(
			ofType(loadApiRootAction),
			switchMap(() =>
				this.apiRootService.load().pipe(
					map(apiRoot => loadApiRootSuccessAction({ apiRoot })),
					catchError(applyDefaultErrorHandling)
				)
			)
		)
	);
}
